module.exports = "../../app/cells/components/questions/banner_cell.rb";